import MainCarousel from "./mainCarousel";
import PhotoTour from "./photoTour";
import React, { useEffect, useRef } from "react";
import AsSeenOnLogos from "@/app/(custom-header)/prizes/house-v2/components/AsSeenOnLogos";
import AccordionDetails from "@/app/(custom-header)/prizes/house-v2/components/AccordionDetails";
import HomeSpecs from "@/app/(custom-header)/prizes/house-v2/components/HomeSpecs";

const HouseCompetitionForDesktop = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current === null) {
      return;
    }
    const onObserving: IntersectionObserverCallback = entries => {
      const moveButtonUp = new CustomEvent("moveButtonUp", { detail: entries[0].isIntersecting });
      window.dispatchEvent(moveButtonUp);
    };
    const observer = new IntersectionObserver(onObserving);
    observer.observe(containerRef.current!);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className={`flex flex-col size-full lg:h-[calc(100vh-60px)] relative`} ref={containerRef}>
        <MainCarousel />
      </div>

      <div className={"px-8 py-16"}>
        <div className={"w-full max-w-[1360px] mx-auto relative flex flex-col gap-16"}>
          <HomeSpecs />
          <AsSeenOnLogos />
          <PhotoTour />
          <AccordionDetails />
        </div>
      </div>
    </>
  );
};

export default HouseCompetitionForDesktop;
